import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from "./router/routers";
import store from "./store";


import './assets/css/public.css'
import './assets/iconfont/iconfont.css'

import './utils/message'
import './router/index'
import './utils/common'
import Dict from "@/utils/Dict";
Vue.directive('removeAriaHidden', {
  // eslint-disable-next-line no-unused-vars
  bind(el, binding) {
    let ariaEls = el.querySelectorAll('.el-radio__original');
    ariaEls.forEach((item) => {
      item.removeAttribute('aria-hidden');
    });
  }
});

Vue.config.productionTip = false

import eventBus from "@/utils/eventBus.js";
Vue.prototype.$eventBus = eventBus;

/**
 * 配置文件
 * @type {{}}
 */
Vue.prototype.$dict = new Dict();

Vue.use(ElementUI, {size: 'mini'})

new Vue({
  ElementUI,
  router,
  store,
  render: h => h(App),
}).$mount('#app')
